export default function ProjectManagerDashboard() {
  return <div className="text-white">Project Manager Dashboard - Coming Soon!</div>;
}
